import { vehicleTypeConfig } from '@components/MainWidget/common/commonWidgetConfig'

export const getPucDataWithFallback = (vehicleData, pucData) => ({
    vehicle_type: vehicleTypeConfig[vehicleData?.vehicle_type_v2] || vehicleTypeConfig.DEFAULT,
    mm_name: vehicleData?.model_name || null,
    previous_policy_expiry_date: vehicleData?.previous_policy_expiry_detail || null,
    expiry_date: pucData?.expiry_date || '-',
  })
